//import 'babel-polyfill';

import {footerInjectTargetSelector, footerInjectInside, footerComponentId, noHTTPSWarningMessage} from '@app/settings';
import Vue from 'vue';
import store from '@app/store';
import router from '@app/router';
import VueResource from 'vue-resource';
import VeeValidate from 'vee-validate';
import helpers from '@app/helpers';
import {Modal, Collapse, Form, FormGroup, FormSelect, FormInput, InputGroup} from 'bootstrap-vue/es/components';
import PortalVue from 'portal-vue';
import App from '@templates/app';
import {throttle} from 'lodash';
import mixins from '@app/mixins/mixins';
import VueAffix from 'vue-affix';
import VueGtm from 'vue-gtm';
import {brand} from '@brand/settings';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';


Raven
	.config('https://34ec07f54dfc4bf29319db70f1e768ee@sentry.io/1223352', {
		environment: process.env.NODE_ENV
	})
	.addPlugin(RavenVue, Vue)
	.install();

Vue.mixin(helpers);
Vue.mixin(mixins);
Vue.use(VueResource);
Vue.use(VeeValidate);
Vue.use(Modal);
Vue.use(Collapse);
Vue.use(Form);
Vue.use(FormGroup);
Vue.use(FormSelect);
Vue.use(FormInput);
Vue.use(InputGroup);
Vue.use(PortalVue);
Vue.use(VueAffix);
Vue.use(VueGtm, {
	debug: false,
	vueRouter: router
});

Vue.http.options.root = process.env.API_BASE;
Vue.http.headers.common.Accept = 'application/json';

Vue.http.interceptors.push(function(request, next) {

	if (request.url === 'https://alerts-api-dev.omnifitrgsites.co.uk/events' || request.url === 'https://alerts-api.omnifitrgsites.co.uk/events') {
		request.headers.delete('X-Auth-BrandToken');
	} else {
		request.headers.set('content-type', 'application/x-www-form-urlencoded');
		request.headers.set('X-Auth-BrandToken', process.env.BRAND_TOKEN);
		request.headers.set('X-iOrder-User-Agent', 'WLWO - OmnifiTRG');
	}

	next();
});


Vue.config.productionTip = process.env.NODE_ENV === 'production';

router.beforeEach((to, from, next) => {

	let meta = to.meta || {};

	// console.log('Going to:', to.name);

	/* If brand is offline push to Offlines page*/
	if (to.name !== 'Offline' && store.state.offline) {
		return next({replace: true, name: 'Offline'});
	}

	// clear the saved braintree payment method
	if (meta.resetBraintree) {
		store.commit('resetPaymentMethod');
		store.commit('resetOrder');

		if (store.state.order.accountNumber) {
			store.dispatch('resetBasket');
		}
	}

	/* clear menus and basket */
	if (meta.clearMenus) store.dispatch('clearMenus');

	// protects routes that need a user to be logged in
	if (meta.requiresAuth && !store.getters.isUserLoggedIn) return next({replace: true, name: 'Login'});

	// these pages need a location to be selected
	if (meta.requiresSiteId && !store.getters.siteId) return next({replace: true, name: 'Locations'});

	// these pages need a basket to have items
	if (meta.requiresABasket && store.getters.isBasketEmpty) return next({replace: true, name: 'Menu'});

	// these pages need a basket id
	if (meta.requiresBasketId && !store.getters.basketId) return next({replace: true, name: 'Basket'});

	/* If the user is going from Checkout to Basket (which does not exist on desktop) - push to Menu */
	if (from.name === 'Checkout' && to.name === 'Basket' && store.state.breakpoint !== 'initial') return next({replace: true, name: 'Menu'});

	next();

});

router.afterEach((to, from) => {
	/* Add last route to Vuex */
	store.dispatch('setLastRoute', from.path);
	// if param action = logout them clear local storage
	if (to.params && to.params.action === 'logout') store.commit('logOut');
	// setup Rakuten global tag
	(function(url) {
		if (!window.DataLayer) {
			window.DataLayer = {};
		}
		if (!window.DataLayer.events) {
			window.DataLayer.events = {};
		}
		window.DataLayer.events.SPIVersion = window.DataLayer.events.SPIVersion || '3.0';
		window.DataLayer.events.SiteSection = '1';
		// eslint-disable-next-line
		var loc, ct = document.createElement('script');
		ct.type = 'text/javascript';
		ct.async = true;
		ct.src = url;
		loc = document.getElementsByTagName('script')[0];
		loc.parentNode.insertBefore(ct, loc);
	}(document.location.protocol + '//intljs.rmtag.com/115836.ct.js'));
});

window.trg = {};

let footerComponentWrapper = document.createElement('div');
let footerComponentTarget = (footerInjectTargetSelector) ? document.querySelectorAll(footerInjectTargetSelector)[0] : document.body;
footerComponentWrapper.id = footerComponentId;
if (footerInjectInside || !footerInjectTargetSelector) footerComponentTarget.appendChild(footerComponentWrapper);
else footerComponentTarget.parentNode.insertBefore(footerComponentWrapper, footerComponentTarget.nextSibling);

if (window.location.protocol === 'https:') {

	new Vue({
		store,
		el: '#app',
		router,
		components: {App},
		template: '<App/>',
		methods: {

			/* Dispatch event to state and update with breakpoint name */
			breakpoint(event) {

				const width = (event) ? event.target.innerWidth : window.innerWidth;

				if (width > 1440)
					this.$store.dispatch('setBreakpoint', 'extra-large');
				else if (width > 1280)
					this.$store.dispatch('setBreakpoint', 'large');
				else if (width > 1024)
					this.$store.dispatch('setBreakpoint', 'medium');
				else if (width > 860)
					this.$store.dispatch('setBreakpoint', 'small');
				else
					this.$store.dispatch('setBreakpoint', 'initial');
			}
		},
		mounted() {

			Raven.setTagsContext({
				brand: brand
			});

			/* Check if app is running inside iframe */
			this.$store.dispatch('detectIframe');

			/* Trigger page load breakpoint */
			this.breakpoint();

			/* Bind throttled event to window reszie */
			window.addEventListener('resize', throttle((event) => {
				this.breakpoint(event);
			}, 350));

			/* Set body style */
			if (brand === 'chiquito') document.body.style.background = '#f6f6f6';
			if (brand === 'c2c' || brand === 'fs') document.body.style.background = '#f5f4f5';
		}
	});

} else {
	document.write(noHTTPSWarningMessage);
}



// WEBPACK FOOTER //
// ./src/vue/app.js